export default __webpack_public_path__ + "_/images/svg_icons/logo-framed-851755b67c5a98c576d023ca4d0f69d2c07e7f1bb2388fbfe9fefcc8913a8607.svg";